import API from '@/shared/plugins/Api/API'

class DeploysV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _tagUrl (appName, tagName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}/tag/${encodeURIComponent(tagName)}`
  }

  async start (appName, tagName, { force, options } = {}) {
    const params = {}
    if (force) params.force = true
    await this.request({
      method: 'post',
      url: `${this._tagUrl(appName, tagName)}/deploy/start`,
      data: options ? { options } : {},
      params
    })
  }

  async restart (appName, tagName) {
    await this.request({
      method: 'post',
      url: `${this._tagUrl(appName, tagName)}/deploy/restart`
    })
  }

  async stop (appName, tagName, { force } = {}) {
    const data = {}
    if (force) data.force = true
    await this.request({
      method: 'post',
      url: `${this._tagUrl(appName, tagName)}/deploy/stop`,
      data
    })
  }
}

export default DeploysV3
